import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Still an idiot, but with a sexy desktopo now",
  "description": "",
  "published": "2008-07-22T00:00:00.000Z",
  "redirect_from": ["/blog/still-an-idiot-but-with-a-sexy-desktopo-now/swizec/91"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So as it turns out I'm such an idiot as to forget to mention why exactly I was an idiot in the first place when `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=339"
      }}>{`previously talking about idiocy`}</a>{` . What I was going to mention was why exactly it is that Lestat took so long to get fixed up and why he wasn't working in the first place. As it turns out processors have separate power connectors these days and I quite simply didn't connect it and thus ... problems.`}</p>
    <p>{`But let's put all of that aside for now, I'm here to talk about how sexy linux has become, well it's been sexy before but I've never quite tapped into the vast expense of sexiness available to me for one reason or another. Of course I've mentioned some of this before, but this time there's a video and with window decorations all fixed up and sexy as well.`}</p>
    <p>{`You might notice that there's still a bunch of other plugins I could have enabled, shown even, but I didn't because I either don't know about them or was, for the time being, too dazzled by all of this as it was to think of even more sexy things to find.`}</p>
    <p>{`Somewhere at around 2:32 in the video you might notice me adding a cup of tea on the desktop. That's my `}<a parentName="p" {...{
        "href": "http://kde-look.org/content/show.php/Tea+Cooker?content=85564"
      }}>{`Tea Cooker plasmoid`}</a>{` I was talking about making. So far it's had a night's worth of development put in and me basically learning everything I did along the way ... SVG graphics, by the by, are bloody awesome things. It's not very useful yet but it's had 23 downloads in what is essentially a single day. That's surprisingly plenty for something that doesn't even half work yet (can't quite stop/start/reset the timer yet) and I `}<em parentName="p">{`do`}</em>{` intend on making it a lot better, but am having some trouble with libraries and such so I'm waiting for the final release of kde4.1 in hopes it solves my problems.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      